import { getters } from './getters';
import * as actions from './actions';
import { state } from './models';
import { mutations } from './mutations';

export const menuInitialRecommendationModule = {
  state,
  getters,
  actions,
  mutations,
};
